import type { TranslationInterface } from '.';

export const DanishLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Skriv en besked...',
  your_issue_has_been_resolved: 'Dit problem er løst!',
  new_conversation: 'Ny samtale',
  welcome_screen_title: 'Velkommen til vores support chat',
  welcome_screen_description:
    'Vi er her for at hjælpe! Start en samtale, og vi vender tilbage til dig så hurtigt som muligt.',
  your_name_placeholder: 'Dit navn',
  your_email_placeholder: 'Din e-mailadresse',
  start_chat_button: 'Tal med support',
  start_chat_button_loading: 'Forbinder...',
  i_need_more_help: 'Jeg har brug for mere hjælp',
  this_was_helpful: 'Dette var nyttigt',
  optional: 'Valgfrit',
  no_conversations_yet: 'Ingen samtaler endnu',
  back_to_conversations: 'Tilbage til samtaler',
  closed_conversations: 'Lukkede samtaler',
  csat_title: 'Hvordan var din samtale?',
  csat_submitted_title: 'Du vurderede samtalen som',
  csat_feedback_placeholder: 'Fortæl os mere... (valgfrit)',
  follow_up_placeholder: 'Følg op…',
  companion_layout_label: 'Layout',
  companion_layout_floating: 'Flydende',
  companion_layout_sidebar: 'Sidepanel',
  companion_layout_fullscreen: 'Fuld skærm',
  companion_close: 'Luk',
  companion_history: 'Samtalehistorik',
  companion_expand_chat: 'Udvid chat',
  companion_sidebar_dock_label: 'Dok',
  companion_sidebar_side_label: 'Side',
  companion_sidebar_left: 'Venstre',
  companion_sidebar_right: 'Højre',
  companion_resize_chat: 'Tilpas chatstørrelse',
  scroll_to_bottom: 'Rul til bunden',
  thinking: 'Tænker…',
  running: 'Kører…',
  steps: 'trin',
  step_arguments: 'Argumenter',
  step_result: 'Resultat',
  attach_files:
    'Vedhæft billeder, videoer, PDF-filer eller regneark (maksimal størrelse 25 MB)',
  mark_page_active:
    'Klik på noget på siden for at markere det — Esc annullerer',
  mark_page: 'Markér noget på siden for at spørge om det',
  stop_response: 'Stop svar',
  copy_reply: 'Kopiér svar',
  mentions_empty: 'Ingen resultater',
  copied: 'Kopieret',
  send_message: 'Send besked',
  upload_failed: 'Upload mislykkedes: {error}',
  remove_attachment: 'Fjern vedhæftning',
  json_no_items: 'Ingen elementer',
  json_no_data: 'Ingen data',
  json_no_chart_data: 'Ingen data til diagram',
  json_unsupported: 'Ikke understøttet: {type}',
  json_see_less: 'Vis mindre',
  json_phone_agent: 'Telefonagent',
  json_phone_agent_test: 'Test via web',
  page_context_remove: 'Fjern sidekontekst',
  json_see_more: 'Vis {count} mere',
  queued_label: '{count} I kø',
  remove_queued_message: 'Fjern besked fra køen',
  send_queued_now: 'Send beskeder i køen nu',
  turn_failed_message: 'Noget gik galt, og svaret kom ikke frem.',
  turn_failed_retry: 'Prøv igen',
  page_mark_hint: 'Klik på noget for at markere det',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Firkant',
  page_mark_shape_circle: 'Cirkel',
  page_mark_shape_arrow: 'Pil',
  page_mark_shape_bracket: 'Kantparentes',
  page_mark_shape_underline: 'Understregning',
  page_mark_shape_highlight: 'Fremhævning',
  page_mark_shape_strike_through: 'Gennemstregning',
  page_mark_shape_crossed_off: 'Kryds ud',
  page_mark_shape_aria: 'Markeringsform: {shape}',
  page_mark_note_placeholder: 'Tilføj en note… (Enter for at vedhæfte)',
  page_mark_attach: 'Vedhæft markering',
  page_mark_remove: 'Fjern {label}',
  page_mark_region: 'Markeret område',
  page_mark_default_message: 'Hvad er det her?',
  file_rejected: 'Filtypen understøttes ikke, eller filen er for stor.',
  dictate: 'Dikter',
  stop_dictation: 'Stop diktering',
  dictation_mic_blocked: 'Tillad mikrofonadgang for at diktere',
  dictation_unavailable: 'Diktering er ikke tilgængelig lige nu',
  questions_back: 'Tilbage',
  questions_next: 'Næste',
  questions_send: 'Send',
  questions_type_answer: 'Jeg skriver det selv',
  questions_answer_placeholder: 'Skriv dit svar…',
  close_conversation_title: 'Luk samtale',
  close_conversation_description:
    'Er du sikker på, at du vil lukke denne samtale?',
  close_conversation_cancel: 'Nej',
  close_conversation_confirm: 'Ja',
  dialog_close: 'Luk',
  zoom_in: 'Zoom ind',
  zoom_out: 'Zoom ud',
  reset_zoom: 'Nulstil zoom',
  support_chat_aria_label: 'Supportchat',
};
